import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { RiArrowDownSLine } from 'react-icons/ri';
import axios from 'axios';
import PaginationComponent from '../../../utils/PaginationComponent';
import TableLoader from '../../../utils/TableLoader';
import SearchInput from '../../../utils/SearchInput';
import searchIcon from "../../../assets/admin/search.svg";
import AllOrderView from './AllOrderView';

const AllOrderManagement = ((props, ref) => {
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const token = localStorage.getItem("token");
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [showOrder, setShowOrder] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);

    const [orderData, setOrderData] = useState([]);
    const [viewOrderData, setViewOrderData] = useState({});

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [searchQuery, setSearchQuery] = useState("");
    const [searchRestQuery, setSearchRestQuery] = useState("");
    const [showOption, setShowOption] = useState(false);
    const [filteredRestArray, setFilteredRestArray] = useState([]);
    const [selectedRestId, setSelectedRestId] = useState(null);

    const getRestaurantData = async () => {
        setIsLoading2(true);
        try {
            const params = {
                pageNumber: page,
                size: 25,
                search: searchRestQuery,
            };
            const response = await axios.get(`${apiUrl}/api/v1/restaurants`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setFilteredRestArray(response?.data?.data || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading2(false);
        }
    }

    useEffect(() => {
        getRestaurantData();
    }, [searchRestQuery])

    const getOrdersData = async () => {
        setIsLoading(true);
        try {
            let params;
            if (searchQuery) {
                params = {
                    pageNumber: page,
                    size: rowsPerPage,
                    search: searchQuery,
                    restaurant_id: selectedRestId,
                };
            } else {
                params = {
                    pageNumber: page,
                    size: rowsPerPage,
                    restaurant_id: selectedRestId,
                };
            }
            const response = await axios.get(`${apiUrl}/api/v1/all-orders`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = response.data;
            setOrderData(data.data);
            setTotalPages(data.total);
        } catch (error) {
            console.error("Error fetching order data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getViewOrdersData = async () => {
        setIsLoading(true);
        try {
            const OrderId = selectedOrder.id;
            const response = await axios.get(`${apiUrl}/api/v1/orders/${OrderId}/wines`, {
                params: {
                    pageNumber: page,
                    size: rowsPerPage,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = response.data;
            setViewOrderData(data.wines.data);
            setTotalPages(data.total);
        } catch (error) {
            console.error("Error fetching or updating order data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRestSelection = (wineId) => {
        setSelectedRestId((prevRestId) => (prevRestId === wineId ? null : wineId));
        setShowOption(false);
        setPage(1);
    };

    const handleSearchChange = (value) => {
        setSearchQuery(value);
        setPage(1);
    };

    const handleViewOrderClick = (order) => {
        setSelectedOrder(order);
        setShowOrder(true);
    };

    useImperativeHandle(ref, () => ({
        order() {
            setShowOrder(false)
        },
    }));

    useEffect(() => {
        getOrdersData();
        if (selectedOrder) {
            getViewOrdersData();
        }
    }, [page, rowsPerPage, selectedRestId, selectedOrder, searchQuery]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest(".dropdown-container")) {
                setShowOption(false);
            }
        };
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    return (
        <>
            <section className="border-t border-[#D9D9D9] mt-5 pt-5">
                {showOrder && selectedOrder ? (
                    <>
                        <div className='flex justify-between'>
                            <div>
                                <h3 className="flex text-3xl font-bold mb-2 poppins-medium items-center">
                                    {selectedOrder?.order_number || 'N/A'}
                                </h3>
                            </div>
                            <p className='text-lg font-normal poppins-medium mr-4'>
                                {selectedOrder?.order_date ? (
                                    new Date(selectedOrder?.order_date).toLocaleDateString("en-GB").replace(/\//g, "-")
                                ) : (
                                    <span className="text-gray-400">N/A</span>
                                )}
                            </p>
                        </div>
                        <AllOrderView
                            viewOrderData={viewOrderData}
                            isLoading={isLoading}
                        />
                    </>
                ) : (
                    <>
                        <div className="flex lg:flex-row flex-col justify-between items-center mt-3 mb-5 w-full">
                            <h3 className="text-3xl font-bold mb-3 xl:mb-0 poppins-medium self-start">Tutti Gli Ordini</h3>
                            <div className="self-start flex items-center gap-4 md:flex-row flex-col sm:w-auto w-full">
                                <SearchInput
                                    onSearchChange={handleSearchChange}
                                    component="Order Management"
                                    placeholder="Ordini"
                                />
                                <div className="w-full flex flex-col lg:flex-row gap-2 dropdown-container">
                                    <div className="relative group w-full">
                                        <button
                                            className={`${showOption ? "border-b-0 rounded-tl-3xl rounded-tr-3xl" : "rounded-full"} py-[5px] border-[2px] bg-[#fff] border-[#F2C3CA] inline-flex justify-between items-center w-full px-4 outline-none text-[#8B2433] font-medium shadow-sm relative z-30`}
                                            onClick={() => setShowOption(!showOption)}
                                        >
                                            {/* <span className="mr-2 flex items-center gap-3 poppins-regular">
                                                {selectedRestId
                                                    ? (filteredRestArray.find((rest) => rest.id === selectedRestId)?.restaurant_name?.length > 25
                                                        ? filteredRestArray.find((rest) => rest.id === selectedRestId)?.restaurant_name?.slice(0, 25) + "..."
                                                        : filteredRestArray.find((rest) => rest.id === selectedRestId)?.restaurant_name) || "Scegli Ristorante"
                                                    : "Scegli Ristorante"}
                                            </span> */}
                                            <span className="mr-2 flex items-center gap-3 poppins-regular">
                                                {selectedRestId
                                                    ? (() => {
                                                        const selectedRestaurant = filteredRestArray.find((rest) => rest.id === selectedRestId);
                                                        const restaurantName = selectedRestaurant?.restaurant_name;
                                                        const restaurantCode = selectedRestaurant?.code;

                                                        if (restaurantName && restaurantCode) {
                                                            return restaurantName.length > 25
                                                                ? `${restaurantName.slice(0, 25)}... - ${restaurantCode}`
                                                                : `${restaurantName} - ${restaurantCode}`;
                                                        } else if (restaurantName) {
                                                            return restaurantName.length > 25
                                                                ? `${restaurantName.slice(0, 25)}...`
                                                                : restaurantName;
                                                        } else if (restaurantCode) {
                                                            return restaurantCode;
                                                        } else {
                                                            return "Scegli Ristorante";
                                                        }
                                                    })()
                                                    : "Scegli Ristorante"}
                                            </span>
                                            <RiArrowDownSLine
                                                className={`transform transition-transform duration-300 ${showOption ? "rotate-180" : ""}`}
                                                size={"24px"}
                                                color="#9f414f"
                                            />

                                        </button>
                                        <div
                                            className={`
${showOption ? "opacity-100 scale-100 visible z-50" : "opacity-0 scale-95 invisible z-20"}
bg-[#fff] h-[200px] border-[#F2C3CA] overflow-y-scroll absolute pt-[9px] rounded-t-none 
border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 
w-full border-[2px] border-[#8B24335C] 
transition-all duration-300 ease-in-out transform origin-top
`}
                                        >
                                            <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[28px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                                                <img
                                                    src={searchIcon}
                                                    className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                                                    alt="Search"
                                                />
                                                <input
                                                    type="text"
                                                    className="block poppins-regular bg-transparent outline-none cursor-pointer w-full placeholder:text-sm" placeholder="scegi ristorante"
                                                    value={searchRestQuery}
                                                    onChange={(e) => setSearchRestQuery(e.target.value)}
                                                />
                                            </div>
                                            {isLoading2 ? (
                                                <div role="status" className="flex justify-center items-center h-full">
                                                    <svg
                                                        aria-hidden="true"
                                                        className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#8B2433]"
                                                        viewBox="0 0 100 101"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                            fill="currentColor"
                                                        />
                                                        <path
                                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                            fill="currentFill"
                                                        />
                                                    </svg>
                                                    <span className="sr-only poppins-medium">Loading...</span>
                                                </div>
                                            ) : (
                                                <>
                                                    {filteredRestArray && filteredRestArray?.length > 0 ? (
                                                        filteredRestArray?.map((rest) => (
                                                            <label
                                                                htmlFor=""
                                                                key={rest?.id}
                                                                className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    name="wineSelection"
                                                                    className="outline-none cursor-pointer"
                                                                    checked={selectedRestId === rest?.id}
                                                                    onChange={() => handleRestSelection(rest?.id)}
                                                                />
                                                                <span className="text-[#303030] rounded-md flex items-center gap-3 poppins-regular text-xs">
                                                                    {/* {rest?.id} */}
                                                                    {rest?.restaurant_name ? `${rest?.restaurant_name} -` : ""} {rest?.code}
                                                                </span>
                                                            </label>
                                                        ))
                                                    ) : (
                                                        <p className="text-gray-500 text-sm">No Restaurants available.</p>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-auto dash-table-main h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow">
                            <table className="md:w-full w-[700px] text-left wine_table">
                                <thead>
                                    <tr className="border-b border-[#8B2433]">
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Sr.no</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">N.Ristoranti</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Nome Ristorante & Codice</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">N.Ordine</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Data Ordine</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Stato Ordine</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B] w-[14%]">Azione</th>
                                        {/* <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Opzioni</th> */}
                                    </tr>
                                </thead>
                                {isLoading ? (
                                    <TableLoader />
                                ) : (
                                    <tbody>
                                        {orderData && orderData?.length > 0 ? (
                                            orderData
                                                .map((order, index) => {
                                                    const serialNumber = (page - 1) * rowsPerPage + index + 1;
                                                    return (
                                                        <tr key={order.id} className="border-b border-[#8B2433]/12">
                                                            <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{serialNumber}</td>
                                                            <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{order?.restaurant_id}</td>
                                                            <td className="py-4 px-2 text-left poppins-medium text-[#303030] uppercase">{order?.restaurant?.restaurant_name ? `${order?.restaurant?.restaurant_name} -` : ""} {order?.restaurant?.code}</td>
                                                            <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{order?.order_number}</td>
                                                            <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                                {order?.order_date ? (
                                                                    new Date(order.order_date).toLocaleDateString("en-GB").replace(/\//g, "-")
                                                                ) : (
                                                                    <span className="text-gray-400">N/A</span>
                                                                )}
                                                            </td>
                                                            <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                                {order?.status === "Transmitted"
                                                                    ? "Trasmesso"
                                                                    : order?.status === "Received"
                                                                        ? "Ricevuto"
                                                                        : order?.status === "In Transit"
                                                                            ? "In Transito"
                                                                            : order?.status === "Accepted"
                                                                                ? "Accettato"
                                                                                : order?.status === "Refused"
                                                                                    ? "Rifiutato"
                                                                                    : order?.status || "Select Status"}

                                                            </td>
                                                            <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                                <button
                                                                    onClick={() => { handleViewOrderClick(order) }}
                                                                >
                                                                    Visualizza ordine
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                        ) : (
                                            <tr>
                                                <td colSpan={9} className="text-center py-4">Nessun ordine trovato</td>
                                            </tr>
                                        )}
                                    </tbody>
                                )}
                            </table>
                        </div>
                        {orderData && orderData?.length > 0 && (
                            <PaginationComponent
                                page={page}
                                totalPages={totalPages}
                                rowsPerPage={rowsPerPage}
                                setPage={setPage}
                                setRowsPerPage={setRowsPerPage}
                            />
                        )}
                    </>
                )}
            </section>
        </>
    );
})

export default forwardRef(AllOrderManagement);